<template>
  <div class="btn-group" role="group" aria-label="Выбор языка">
    <button
      v-for="lang in languages"
      :key="lang.value"
      type="button"
      class="btn"
      :class="activeLang === lang.value ? 'btn-secondary' : 'btn-outline-primary'"
      @click="$store.commit('setLang', lang.value)"
    >
      {{ lang.label }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languages: [
        { value: 'ua', label: 'UA' },
        { value: 'ru', label: 'RU' },
        { value: 'en', label: 'EN' }
      ]
    }
  },
  computed: {
    activeLang() {
      return this.$store.getters.activeLang
    }
  }
}
</script>
